import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
} from "@mui/material";
import { CloseIconFill } from "../../../ImageRepo";
import ShepButton from "../ShepButton";
import "./ShepDialog.css";

/*
 * ShepAlertDialog - Replacement for alert() that just displays a message with an OK button
*/
const ShepAlertDialog = ({
  open,
  onClose,
  title = "Alert",
  message,
  buttonLabel = "OK",
  variant = "info",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "9px",
          overflow: "hidden",
        },
      }}
      sx={{ zIndex: 1900 }}
    >
      <DialogTitle
        sx={{
          backgroundColor: "var(--primary-main)",
          color: "var(--default-light)",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          py: 1.5,
          px: 2,
        }}
      >
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
        <IconButton
          onClick={onClose}
          sx={{ color: "var(--default-light)", p: 0.5 }}
          aria-label="Close dialog"
        >
          <CloseIconFill style={{ width: 14, height: 14 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{
          pt: 2,
          pb: 2,
          px: 3,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "80px",
        }}
      >
        <Typography
          variant="body1"
          sx={{
            color: "var(--text-primary)",
            whiteSpace: "pre-line",
            fontSize: "var(--font-sm)",
            textAlign: "center",
          }}
        >
          {message}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2, justifyContent: "center" }}>
        <ShepButton variant="primary" size="small" onClick={onClose}>
          {buttonLabel}
        </ShepButton>
      </DialogActions>
    </Dialog>
  );
};

ShepAlertDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string,
  message: PropTypes.string.isRequired,
  buttonLabel: PropTypes.string,
  variant: PropTypes.oneOf(["info", "success", "warning", "error"]),
};

export default ShepAlertDialog;
